module.exports = __webpack_public_path__ + "img/130.b173e81a.jpg";